// extracted by mini-css-extract-plugin
export default {"contentWrapper":"src-pages-CatalogList--contentWrapper","catalogList":"src-pages-CatalogList--catalogList","sliderWrapper":"src-pages-CatalogList--sliderWrapper"};